
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-dinas/penetapan/kirim/konfirmasi",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-dinas/penetapan/kirim/konfirmasi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-dinas/penetapan/kirim/konfirmasi"])
      });
    }
  